import api from './Api'

// Entorno Grupo: plantillas de comodato del grupo (solo Administradores de Grupo)
const route = '/grupo-comodato'
const json = { headers: { 'Content-Type': 'application/json' } }

export default {
  // Listado sin cláusulas: incluye la plantilla de Pivot Fleet (is_system) y las del grupo
  list: () => api().get(route),
  // Detalle con cláusulas
  view: id => api().get(`${route}/${id}`),
  // { name, title?, subtitle?, clauses? }. Sin clauses es el lienzo en blanco (201)
  create: payload => api().post(route, payload, json),
  // { name?, title?, subtitle?, clauses? }. Sobre la de Pivot Fleet devuelve una copia del grupo con otro id
  update: (id, payload) => api().put(`${route}/${id}`, payload, json),
  remove: id => api().delete(`${route}/${id}`),
  duplicate: (id, payload = {}) => api().post(`${route}/${id}/duplicate`, payload, json),
  publish: id => api().post(`${route}/${id}/publish`),
  unpublish: id => api().post(`${route}/${id}/unpublish`),
  // Devuelve el listado actualizado
  setDefault: id => api().post(`${route}/${id}/set-default`)
}
